var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{on:{"click":function($event){return _vm.back()}}},[_c('img',{attrs:{"src":require("@/assets/img/back-icon.svg"),"alt":"preview"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }